import AScene from './AScene.js';
import AImage from './AImage.js';
import Phaser from 'phaser';

export default class AContainer extends Phaser.GameObjects.Container
{
    /**
     * @param {AScene} scene 
     */
    constructor(scene, x=0, y=0)
    {
        super(scene, x, y);
        this.scene = scene;
    }

    /**
     * @return {Phaser.GameObjects.Image}
     */
    create(x, y, key, atlas = this.scene.defaultAtlas)
    {
        let sprite = new AImage(this.scene, x, y, atlas, key);
        this.add(sprite);
        return sprite;
    }
}